{
  "labels": {
    "paste": "Qoyıw",
    "pasteAsPlaintext": "Ápiwayı tekst retinde qoyıw",
    "pasteCharts": "Diagrammalardı qoyıw",
    "selectAll": "Barlıǵın tańlaw",
    "multiSelect": "",
    "moveCanvas": "",
    "cut": "Qıyıw",
    "copy": "Kóshirip alıw",
    "copyAsPng": "Almasıw buferine PNG retinde kóshirip alıw",
    "copyAsSvg": "",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "",
    "sendToBack": "",
    "bringToFront": "",
    "sendBackward": "",
    "delete": "Óshiriw",
    "copyStyles": "",
    "pasteStyles": "",
    "stroke": "Jiyek",
    "changeStroke": "",
    "background": "Fon",
    "changeBackground": "",
    "fill": "",
    "strokeWidth": "",
    "strokeStyle": "",
    "strokeStyle_solid": "",
    "strokeStyle_dashed": "",
    "strokeStyle_dotted": "",
    "sloppiness": "",
    "opacity": "",
    "textAlign": "",
    "edges": "Qırlar",
    "sharp": "",
    "round": "",
    "arrowheads": "",
    "arrowhead_none": "",
    "arrowhead_arrow": "Jebe",
    "arrowhead_bar": "",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Shrift ólshemi",
    "fontFamily": "",
    "addWatermark": "",
    "handDrawn": "",
    "normal": "",
    "code": "Kod",
    "small": "",
    "medium": "",
    "large": "Úlken",
    "veryLarge": "Júdá úlken",
    "solid": "",
    "hachure": "",
    "zigzag": "",
    "crossHatch": "",
    "thin": "Jińishke",
    "bold": "Qalıń",
    "left": "",
    "center": "",
    "right": "",
    "extraBold": "",
    "architect": "",
    "artist": "",
    "cartoonist": "",
    "fileTitle": "Fayl ataması",
    "colorPicker": "",
    "canvasColors": "",
    "canvasBackground": "",
    "drawingCanvas": "",
    "clearCanvas": "",
    "layers": "",
    "actions": "Háreketler",
    "language": "Til",
    "liveCollaboration": "",
    "duplicateSelection": "Nusqa",
    "untitled": "Atamasız",
    "name": "Ataması",
    "yourName": "Atıńız",
    "madeWithExcalidraw": "Excalidraw járdeminde islengen",
    "group": "",
    "ungroup": "",
    "collaborators": "Qatnasıwshılar",
    "toggleGrid": "",
    "addToLibrary": "Kitapxanaǵa qosıw",
    "removeFromLibrary": "Kitapxanadan alıp taslaw",
    "libraryLoadingMessage": "Kitapxana júklenbekte…",
    "libraries": "Kitapxanalardı kóriw",
    "loadingScene": "Saxna júklenbekte…",
    "loadScene": "",
    "align": "",
    "alignTop": "",
    "alignBottom": "",
    "alignLeft": "",
    "alignRight": "",
    "centerVertically": "",
    "centerHorizontally": "",
    "distributeHorizontally": "",
    "distributeVertically": "",
    "flipHorizontal": "",
    "flipVertical": "",
    "viewMode": "Kóriw rejimi",
    "share": "Bólisiw",
    "showStroke": "",
    "showBackground": "",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "Jeke kitapxana",
    "excalidrawLib": "Excalidraw kitapxanası",
    "decreaseFontSize": "Shrift ólshemin kishireytiw",
    "increaseFontSize": "Shrift ólshemin úlkeytiw",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "Siltemeni ózgertiw",
      "editEmbed": "",
      "create": "",
      "label": "Silteme",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Qatardı ózgertiw",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Qulıplaw",
      "unlock": "Qulıptan shıǵarıw",
      "lockAll": "Barlıǵın qulıplaw",
      "unlockAll": "Barlıǵın qulıptan shıǵarıw"
    },
    "statusPublished": "",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "",
    "exportJSON": "",
    "exportImage": "Súwretti eksportlaw...",
    "export": "Retinde saqlaw...",
    "copyToClipboard": "Almasıw buferine kóshirip alındı",
    "copyLink": "",
    "save": "Ámeldegi faylǵa saqlaw",
    "saveAs": "Retinde saqlaw",
    "load": "Ashıw",
    "getShareableLink": "",
    "close": "Jabıw",
    "selectLanguage": "Tildi tańlaw",
    "scrollBackToContent": "",
    "zoomIn": "",
    "zoomOut": "",
    "resetZoom": "",
    "menu": "Menyu",
    "done": "Tayın",
    "edit": "Ózgertiw",
    "undo": "",
    "redo": "",
    "resetLibrary": "",
    "createNewRoom": "",
    "fullScreen": "Tolıq ekran",
    "darkMode": "Qarańǵı tema",
    "lightMode": "Jaqtı tema",
    "systemMode": "",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "",
    "cancel": "Biykarlaw",
    "saveLibNames": "",
    "clear": "Tazalaw",
    "remove": "Óshiriw",
    "embed": "",
    "publishLibrary": "",
    "submit": "Jiberiw",
    "confirm": "Tastıyıqlaw",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "",
    "importBackendFailed": "",
    "cannotExportEmptyCanvas": "",
    "couldNotCopyToClipboard": "Almasıw buferine kóshirip alıw ámelge aspadı.",
    "decryptFailed": "",
    "uploadedSecurly": "",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "",
    "errorRemovingFromLibrary": "",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "Kitapxananı júklew ámelge aspadı",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "lasso": "",
    "image": "Súwret qoyıw",
    "rectangle": "Tórt múyeshlik",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "Sızıq",
    "freedraw": "Sızıw",
    "text": "Tekst",
    "library": "Kitapxana",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "Óshirgish",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": "Figuralar"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "",
    "button_stopSession": "",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "Qátelik"
  },
  "exportDialog": {
    "disk_title": "Diskke saqlaw",
    "disk_details": "",
    "disk_button": "Faylǵa saqlaw",
    "link_title": "",
    "link_details": "",
    "link_button": "Siltemege eksportlaw",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "Eksportlaw",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "Biziń blogtı oqıń",
    "click": "basıw",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "Hújjetshilik",
    "doubleClick": "",
    "drag": "",
    "editor": "Redaktor",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "yamasa",
    "preventBinding": "",
    "tools": "Ásbaplar",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "Járdem",
    "view": "Kóriw",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "Avtor atı",
    "githubUsername": "GitHub paydalanıwshı atı",
    "twitterUsername": "Twitter paydalanıwshı atı",
    "libraryName": "Kitapxana ataması",
    "libraryDesc": "",
    "website": "Veb-sayt",
    "placeholder": {
      "authorName": "Atıńız yamasa paydalanıwshı atı",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "Kitapxananı qayta ornatıw",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "Súwretti eksportlaw",
    "label": {
      "withBackground": "Fon",
      "onlySelected": "",
      "darkMode": "Qarańǵı tema",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": "Almasıw buferine kóshirip alıw"
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "shapes": "",
    "height": "",
    "scene": "Saxna",
    "selected": "Tańlandı",
    "storage": "",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "",
    "version": "Versiya",
    "versionCopy": "Kóshirip alıw ushın basıń",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "addedToLibrary": "Kitapxanaǵa qosıldı",
    "copyStyles": "",
    "copyToClipboard": "Almasıw buferine kóshirip alındı.",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Fayl saqlandı.",
    "fileSavedToFilename": "{filename} saqlandı",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "Qara",
    "white": "Aq",
    "red": "Qızıl",
    "pink": "Qızǵılt",
    "grape": "",
    "violet": "Qızǵılt kók",
    "gray": "",
    "blue": "Kók",
    "cyan": "Kók aspan",
    "teal": "Piruza",
    "green": "Jasıl",
    "yellow": "Sarı",
    "orange": "Qızǵılt sarı",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": "Eksportlaw, sazlawlar, tiller, ..."
    },
    "defaults": {
      "menuHint": "Eksportlaw, sazlawlar hám basqa...",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "Reńler",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Súwret retinde eksportlaw",
        "button": "Súwret retinde eksportlaw",
        "description": ""
      },
      "saveToDisk": {
        "title": "Diskke saqlaw",
        "button": "Diskke saqlaw",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Fayldan júklew",
        "button": "Fayldan júklew",
        "description": ""
      },
      "shareableLink": {
        "title": "Siltemeden júklew",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
